<div class="qr-modal-wrap" ngbAutofocus>
  <button type="button" class="btn-close qr-modal-close" aria-label="ปิด" (click)="activeModal.close()"></button>
  <div class="qr-modal-handle"></div>
  <h2 class="qr-modal-title">{{ title }}</h2>
  <p class="qr-modal-sub">{{ subtitle }}</p>

  @if (hasQrImage) {
    <div class="qr-modal-img-wrap">
      <img [src]="qrImageUrl" [alt]="title" class="qr-modal-img">
    </div>
    <div class="qr-modal-code-group">
      <span class="qr-modal-code-caption">รหัสอ้างอิงรายการ</span>
      <div class="qr-modal-code-row">
        <span class="qr-modal-code-label">{{ qrCode || '—' }}</span>
        <button type="button" class="qr-modal-copy-button" (click)="copyClicked.emit()"
                aria-label="คัดลอกรหัส QR" title="คัดลอกรหัส QR">
          <i class="bi bi-copy"></i>
          <span>คัดลอก</span>
        </button>
      </div>
    </div>
    <div class="qr-modal-actions">
      <button type="button" class="btn btn-default btn-sm" (click)="exportClicked.emit()">
        <i class="bi bi-download"></i> บันทึกรูป QR Code
      </button>
    </div>
  } @else {
    <div class="qr-modal-empty">
      <i class="bi bi-qr-code"></i>
      <span>บันทึกรายการก่อนจึงสร้าง QR</span>
    </div>
  }
</div>
